<template>
  <div>
    <div class="goback" v-if="props.type">
      <div class="kong"></div>
      <div class="fixback">
        <div class="icon" @click="back()">
          <span class="iconfont icon-xiangzuo"></span>
        </div>
      </div>
    </div>
    <div class="fixback" v-else>
      <div class="icon" @click="back()">
        <span class="iconfont icon-xiangzuo"></span>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "GoBack",
  props: ["type"],
  setup(props) {
    function back() {
      this.$router.go(-1);
    }

    return { back, props };
  },
});
</script>

<style lang="scss" scoped>
.goback {
  .kong {
    height: 0.54rem;
  }
  //   .fixback {
  //     background: #fff;
  //   }
}

.fixback {
  padding: 0.12rem;
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  box-sizing: border-box;
  z-index: 9;
}
.icon {
  width: 0.3rem;
  height: 0.3rem;
  text-align: center;
  line-height: 0.3rem;
  background: rgba(102, 102, 102, 30);
  border-radius: 50%;
  .iconfont {
    color: #fff;
  }
}
</style>
